import { selectComplementaryItemById } from '@store/balance/ComplementaryItemReducer'
import { useAppSelector } from '@store/hooks'
import { selectSelectedMembershipProfileComplementaryItem } from '@store/membership/MembershipProfileComplementaryItemReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(
    selectSelectedMembershipProfileComplementaryItem()
  )
  const complementaryItem = useAppSelector(
    selectComplementaryItemById(item?.complementaryItem!)
  )

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        title={'Are you sure ?'}
        subTitle={`This will permanently delete the member's remaining ${item.quantity} ${complementaryItem ? complementaryItem.en.name : 'credit'}(s). This action is immediate and cannot be undone.`}
      />
      <Form.Item name="id" hidden required rules={[]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
